<template>
  <div class="routeOfAdministrationPicker">
    <h3>Administrationsveje</h3>
    <div class="columnList">
      <div
        v-for="route in list"
        :key="route.id"
      >
        <BaseCheckbox
          v-model="route.selected"
          :label="route.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from './BaseCheckbox.vue';

export default {
    name: 'RouteOfAdministrationPicker',
    components: { BaseCheckbox },
    props: {
        list: { type: Array, required: true },
    },
};
</script>

<style lang="scss" scoped>
.routeOfAdministrationPicker {
    width: 100%;
}
</style>
